function Loading() {
    return (
        <>
        ...
        </>
    )
}

export default Loading;